import { Card } from "primereact/card";
import { Tag } from "primereact/tag";
import { activeCurrencies } from "utils";

const BookRowExpansion = ({ book }) => {
	const hasPhysical = ["physical", "both"].includes(book?.format);

	return (
		<div className="p-4 bg-gray-50 border-t border-gray-200">
			<Card className="shadow-none border-0">
				<div className="grid grid-cols-1 md:grid-cols-3 gap-6">
					{/* Book Details */}
					<div>
						<h4 className="font-semibold text-lg mb-3 text-gray-800">Book Details</h4>
						<div className="space-y-2 text-sm">
							<div>
								<span className="font-medium text-gray-500">ISBN:</span>{" "}
								<span className="text-gray-800">{book?.isbn || "N/A"}</span>
							</div>
							<div>
								<span className="font-medium text-gray-500">Publisher:</span>{" "}
								<span className="text-gray-800">{book?.publisher || "N/A"}</span>
							</div>
							<div>
								<span className="font-medium text-gray-500">Format:</span>{" "}
								<span className="text-gray-800 capitalize">{book?.format || "Digital"}</span>
							</div>
							<div>
								<span className="font-medium text-gray-500">Category:</span>{" "}
								<span className="text-gray-800">{book?.category?.name || "N/A"}</span>
							</div>
							<div>
								<span className="font-medium text-gray-500">Genre:</span>{" "}
								<span className="text-gray-800">{book?.genres?.[0]?.name || "N/A"}</span>
							</div>
						</div>
					</div>

					{/* Pricing & Status */}
					<div>
						<h4 className="font-semibold text-lg mb-3 text-gray-800">Pricing & Status</h4>
						<div className="space-y-2 text-sm">
							<div className="flex items-center gap-2">
								<span className="font-medium text-gray-500">Status:</span>
								<Tag
									value={book?.is_active ? "Active" : "Inactive"}
									severity={book?.is_active ? "success" : "danger"}
								/>
							</div>
							<div className="flex items-center gap-2">
								<span className="font-medium text-gray-500">Book File:</span>
								<Tag
									value={book?.has_book_file ? "Uploaded" : "Missing"}
									severity={book?.has_book_file ? "success" : "danger"}
								/>
							</div>
							<div>
								<span className="font-medium text-gray-500">Digital Price ({activeCurrencies.USD.label}):</span>{" "}
								<span className="text-gray-800">${book?.price || 0}</span>
							</div>
							<div>
								<span className="font-medium text-gray-500">Digital Price ({activeCurrencies.ZWL.label}):</span>{" "}
								<span className="text-gray-800">${book?.zwl_price || 0}</span>
							</div>
							{hasPhysical && (
								<>
									<div>
										<span className="font-medium text-gray-500">Physical Price ({activeCurrencies.USD.label}):</span>{" "}
										<span className="text-gray-800">${book?.physical_usd_price || 0}</span>
									</div>
									<div>
										<span className="font-medium text-gray-500">Physical Price ({activeCurrencies.ZWL.label}):</span>{" "}
										<span className="text-gray-800">${book?.physical_zwl_price || 0}</span>
									</div>
									<div>
										<span className="font-medium text-gray-500">Stock Level:</span>{" "}
										<span className="text-gray-800">{book?.stock_level || 0}</span>
									</div>
								</>
							)}
						</div>
					</div>

					{/* Availability Settings */}
					<div>
						<h4 className="font-semibold text-lg mb-3 text-gray-800">Availability</h4>
						<div className="space-y-2 text-sm">
							<div className="flex items-center gap-2">
								<span className="font-medium text-gray-500">Free:</span>
								<Tag
									value={book?.isFree ? "Yes" : "No"}
									severity={book?.isFree ? "success" : "secondary"}
								/>
							</div>
							<div className="flex items-center gap-2">
								<span className="font-medium text-gray-500">Sellable:</span>
								<Tag
									value={book?.sellable ? "Yes" : "No"}
									severity={book?.sellable ? "success" : "secondary"}
								/>
							</div>
							<div className="flex items-center gap-2">
								<span className="font-medium text-gray-500">On Subscription:</span>
								<Tag
									value={book?.subscription ? "Yes" : "No"}
									severity={book?.subscription ? "success" : "secondary"}
								/>
							</div>
							<div className="flex items-center gap-2">
								<span className="font-medium text-gray-500">Pick of Week:</span>
								<Tag
									value={book?.pick_of_week ? "Yes" : "No"}
									severity={book?.pick_of_week ? "warning" : "secondary"}
								/>
							</div>
							<div className="flex items-center gap-2">
								<span className="font-medium text-gray-500">Recommended:</span>
								<Tag
									value={book?.recommended ? "Yes" : "No"}
									severity={book?.recommended ? "info" : "secondary"}
								/>
							</div>
						</div>
					</div>
				</div>

				{/* Description */}
				{book?.description && (
					<div className="mt-6 pt-4 border-t border-gray-200">
						<h4 className="font-semibold text-lg mb-3 text-gray-800">Description</h4>
						<div
							className="text-sm text-gray-700 prose prose-sm max-w-none"
							dangerouslySetInnerHTML={{
								__html: book?.description || "No description available",
							}}
						/>
					</div>
				)}
			</Card>
		</div>
	);
};

export default BookRowExpansion;
